import React from "react";

const category = [
  { id: 1, name: "Legal", displayOn: ["en", "cn", "ru"] },
  { id: 2, name: "Construction", displayOn: ["en", "cn", "ru"] },
  { id: 3, name: "Rental Program", displayOn: ["en", "cn", "ru"] },
  {
    id: 4,
    name: "Estate And Property Management",
    displayOn: ["en", "cn", "ru"],
  },
  // { id: 4, name: "Property Management", displayOn: ["en", "cn", "ru"] },
  { id: 5, name: "Privileges", displayOn: ["en", "cn", "ru"] },
  { id: 6, name: "Infrastructure & Common Areas", displayOn: ["en", "ru"] },
  // { id: 7, name: "Financing", displayOn: ["en", "cn", "ru"] },
];

const faqs = [
  {
    categoryId: 1,
    question: {
      en: "What types of ownership are available?",
      ru: "Какие формы собственности существуют?",
      cn: "产权有哪些类型?",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Land is available on a leasehold basis. Leases are registered with
            the government (currently for a maximum period of 30 years as
            permitted by law) and are renewable. However, the buildings are sold
            as freehold.
          </p>
          <p>
            The cost of land lease renewals will be borne by the lessee
            according to the contracts.
          </p>
          <p>
            According to current Thai Law, non-Thai’s are entitled to own the
            buildings developed upon the land leased by them, but not the land
            itself. Land will be available for freehold purchase by Thai buyers
            once a land subdivision is completed.
          </p>
          <p>
            Upgrading land from leasehold to freehold title will be available
            once a land subdivision is completed, provided that the lessee is
            eligible under relevant Thai laws and regulations to take transfer
            of and own the land (currently, non-Thai’s are prohibited to acquire
            land on a freehold basis).
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Земля под строением предоставляется во владение на правах
            долгосрочной аренды. Необходима государственная регистрация арендных
            прав (в соответствии с действующим законодательством максимальный
            срок действия регистрации составляет 30 лет) с последующим
            продлением на новый срок. Однако здания таунхаусов и вилл продаются
            в полную собственность.
          </p>
          <p>
            Стоимость продления аренды земли будет покрываться за счет
            арендатора в соответствии с договором.
          </p>
          <p>
            Согласно законодательству Таиланда иностранцы могут приобретать
            здания, построенные на арендованной земле, но не имеют прав на
            владение землей. Земля будет доступна для покупки с полным правом
            владения лицам, являющимся гражданами Таиланда, когда раздел земли
            будет завершен.
          </p>
          <p>
            Переоформление прав аренды на право собственности будет доступно
            после завершения раздела земельных участков при условии, что
            арендатор имеет право в соответствии с законами и нормативными
            правовыми актами Таиланда принимать передачу земли и владеть землей
            (в настоящее время лицам, не являющимся гражданами Таиланда,
            запрещено приобретать землю на правах собственности).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            土地出售基于租赁所有权。物业租赁及续租需要通过政府部门注册。(根据泰国法律，目前
            法律规定最多 30 年的租赁期)。但是房屋建筑部分作为永久产权出售。
            续签租赁所有权 的费用将根据合同由承租人承担。
          </p>
          <p>
            根据现有泰国法律，外籍业主可能获得在其租赁土地上所开发建筑物的所有权，但没有土地
            本身的所有权。在土地细分完成后，泰国业主可以拥有对土地的所有权。
          </p>
          <p>
            在土地细分完成后，若泰国相关法律法规变更允许承租人拥有土地，则可实现租赁权至永久
            产权的升级。(目前，泰国禁止非泰国人以永久产权的方式获得土地)。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en:
        "What are the costs associated with the lease / freehold registration?",
      ru: "Каковы затраты, связанные с арендой / регистрацией собственности?",
      cn: "租赁产权/永久产权登记的相关费用如何?",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>These are outlined below:</p>
          <ul>
            <li>
              <strong>Leasehold land</strong>
              <p>
                Lease registration fees and stamp duty (currently 1.1% of the
                rental or lease premium) is payable to the Land Department upon
                registration of the lease.
              </p>
            </li>
            <li>
              <strong>Freehold buildings</strong>
              <p>
                Freehold registration fee (currently 2% of the appraisal price
                of building) is payable to the Land Department upon transfer and
                registration of ownership of the buildings. The appraisal price
                is calculated relative to the government’s tax assessment value.
                Other applicable taxes upon transfer and registration of
                ownership of the freehold buildings are:
              </p>
              <ul>
                <li className="white-circle">
                  <strong>Corporate Income Tax</strong>
                </li>
                <p>
                  (Currently 1.0% of the selling price or appraisal price,
                  whichever is higher)
                </p>
                <li className="white-circle">
                  <strong>Special Business Tax</strong>
                </li>
                <p>
                  (Currently 3.3% of the selling price or appraisal price,
                  whichever is higher)
                </p>
              </ul>
            </li>
          </ul>
          <p>
            The burden between the seller and the purchaser for the above costs
            will be specified in the Lease and/or Sale & Purchase Agreements.
          </p>
          <p>
            <small>
              <em>
                Note: Applicable registration fees and tax rates are current but
                may be subject to change by the relevant Thai authorities.
              </em>
            </small>
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>Они представлены ниже:</p>
          <ul>
            <li>
              <strong>Регистрация прав аренды на землю</strong>
              <p>
                При регистрации договора аренды в Земельном департаменте
                необходимо оплатить регистрационные сборы и пошлины (в настоящее
                время 1,1 % от стоимости аренды или премиальной надбавки).
              </p>
            </li>
            <li>
              <strong>
                Регистрация прав собственности на недвижимость/землю
              </strong>
              <p>
                При передаче и регистрации права собственности на недвижимость в
                Земельный департамент оплачивается регистрационный взнос (2 % от
                оценочной стоимости объекта). Оценочная стоимость обычно
                рассчитывается относительно значения для определения налоговой
                базы, установленной правительством. Как правило, она значительно
                ниже рыночной стоимости объекта. К другим действующим налогам на
                передачу и регистрацию права собственности относятся следующие:
              </p>
              <ul>
                <li className="white-circle">
                  <strong>Налог на доходы юридических лиц</strong>
                </li>
                <p>
                  (в настоящее время ставка составляет 1,0 % от цены продажи или
                  оценочной стоимости, в зависимости от того, какая из них выше)
                </p>
                <li className="white-circle">
                  <strong>Специальный налог на прибыль</strong>
                </li>
                <p>
                  (в настоящее время ставка составляет 3,3 % от цены продажи или
                  оценочной стоимости, в зависимости от того, какая из них выше)
                </p>
              </ul>
            </li>
          </ul>
          <p>
            Обязательства продавца и покупателя в отношении указанных выше
            расходов описываются в соглашении об аренде и (или) договоре
            купле-продажи.
          </p>
          <p>
            <small>
              <em>
                Примечание: В настоящем документе приведены применимые текущие
                регистрационные сборы и налоговые ставки, но они могут быть
                изменены соответствующими государственными органами Таиланда.
              </em>
            </small>
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>具体条款如下:</p>
          <ul>
            <li>
              <strong>租赁产权土地</strong>
              <p>
                租赁产权登记费和印花税(现为地租或租赁使用费的1.1%)须在登记时向国土资源部缴纳。
              </p>
            </li>
            <li>
              <strong>永久产权建筑</strong>
              <p>
                永久产权登记费(现为物业估价的2%)须在转让和登记建筑产权时向国土资源部缴纳。估价根
                据政府的税务评估值计算得出。转让和登记永久产权建筑时适用的其他税项有:
              </p>
              <ul>
                <li classNme="white-circle">
                  <strong>企业所得税</strong>
                </li>
                <p>(现为售价或估价的1.0%，以较高者为准)。</p>
                <li classNme="white-circle">
                  <strong>特别营业税</strong>
                </li>
                <p>(现为售价或估价的3.3%，以较高者为准)。</p>
              </ul>
            </li>
          </ul>
          <p>
            上述费用中，买卖双方各自承担的费用将在租赁和/或买卖协议中详细说明。
          </p>
          <p>
            <small>
              <em>
                备注:
                请注意，此处的登记费以及某些适用税率适用于现在，根据相关泰国法律有随时更改的可能。
              </em>
            </small>
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en: "Is leasehold land transferable?",
      ru: "Возможна ли передача прав аренды земельного участка?",
      cn: "租赁产权的土地可以转让吗?",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Yes. Leasehold land may be transferred subject to the terms and
            conditions of the lease agreement. Generally, a small fee is
            payable. In addition, the new owner must agree to be bound by the
            terms and conditions contained in the original lease agreement.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Да. Арендованная земля может быть передана в соответствии с
            положениями и условиями соглашения. Как правило, при этом платится
            пошлина. Кроме того, правопреемник должен согласиться соблюдать
            положения и условия, содержащиеся в первоначальном договоре аренды.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            租赁产权的土地可以根据协议的条款和条件进行转让。
            通常需支付少额费用。此外，新业主必须同意接受原租赁协议中所含的条款和条件。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en: "Is leasehold land ownership secure?",
      ru: "Как обеспечивается безопасность аренды земельного владения?",
      cn: "土地的租赁产权是否安全?",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Leasehold land ownership is the preferred method of ownership for
            non-Thais. Once the lease is registered at the Land Department, the
            owner’s rights to the land will be officially recognized.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Владение на правах аренды земли является предпочтительным методом
            владения для лиц, не являющихся гражданами Таиланда. Арендатору
            переходят права пользования землей сразу при регистрации договора в
            Земельном департаменте.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            土地的租赁产权是提供给非泰国业主的最佳产权方式。一旦租赁产权在国土资源部登记后，业
            主对土地的权利将得到正式认可。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en: "When will the lease / house transfer registration take place?",
      ru:
        "Когда будет проходить процесс регистрации прав аренды / передачи дома?",
      cn: "何时进行租赁/房屋转交登记?",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Approximately 90 days after full payment has been received and
            construction is complete. We will notify the owner of any documents
            and fees required for registration.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Примерно через 90 дней после оплаты полной стоимости и завершения
            строительства объекта мы предоставим покупателю список необходимых
            документов и сборов, необходимых для регистрации.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            收到全额付款后约90天，且项目中所有建筑的施工完成后，我们会告知业主登记所需的所有
            文件和费用。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en: "Should I appoint a lawyer to review the agreements?",
      ru: "Должен ли я нанять адвоката для проверки соглашений?",
      cn: "我是否应该委托律师审核协议?",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Our agreements have been used for a number of years and have been
            reviewed by major international law firms. We have our own in-house
            legal team which will assist to clarify any questions you may have
            concerning the agreements. However, should you wish to obtain
            specific advice regarding the structuring of your investment, we
            recommend you consult with a professional legal and/or financial
            adviser.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Наши соглашения используются уже много лет и прошли проверку
            крупными международными юридическими фирмами. У нас есть свои
            юристы, которые могут ответить на любые ваши вопросы по соглашениям.
            Однако, если вы хотите получить конкретные рекомендации по
            структурированию инвестиций, мы рекомендуем проконсультироваться с
            профессиональным юридическим и (или) финансовым консультантом.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            我们的协议已经使用多年，并且已通过各大国际律师事务所的审核。我们拥有自己的内部法律
            团队，可以协助解答您对协议的任何疑问。但是，如果您希望获得关于投资的详细而具体的意
            见，建议您咨询专业法律和/或财务顾问。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en: "What is the measurement of square wah?",
      ru: "Что такое квадратный ваа?",
      cn: "平方瓦(wah)是什么度量单位?",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Our agreements indicate the property’s areas with land measurement
            under the Thai system set by the Land Department. The most commonly
            used land measurements are as follows:
          </p>
          <ul>
            <li>One rai equals 1,600 square meters</li>
            <li>One ngan equals 400 square meters</li>
            <li>One square wah equals 4 square meters</li>
          </ul>
        </div>
      ),
      ru: (
        <div>
          <p>
            Мы обязаны указывать площадь земельных участков в соответствии с
            тайской системой измерения, установленной Земельным департаментом.
            Наиболее часто используется следующая система измерения:
          </p>
          <ul>
            <li>Один рай равен 1600 квадратным метрам</li>
            <li>Один нган равен 400 квадратным метрам</li>
            <li>Один квадратный ваа равен 4 квадратным метрам</li>
          </ul>
        </div>
      ),
      cn: (
        <div>
          <p>
            我们的协议依照国土资源部制定的泰制土地度量单位来表示物业的面积。最常用的土地度量单
            位如下:
          </p>
          <ul>
            <li>1 莱(rai)等于 1,600 平方米</li>
            <li>1 干(ngan)等于 400 平方米</li>
            <li>1 平方瓦(wah)等于 4 平方米</li>
          </ul>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: {
      en:
        "What types of visas are available for foreigners to stay in Thailand?",
      ru: "Какие типы виз доступны иностранцам для пребывания в Таиланде?",
      cn: "外籍人士将能获得何种泰国居留签证?",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            There are various forms of visas available to foreigners who wish to
            enter Thailand for study, business, investment, retirement and other
            purposes ranging from 90 days to 1 year multiple entry which
            include.
          </p>
          <ul>
            <li>
              Education visa when enrolled at registered education institution
              within Thailand
            </li>
            <li>Business visa when operating a business or employed</li>
            <li>
              Retirement visa for people aged 50 years or over and meet
              financial requirements
            </li>
            <li>Marriage visa for foreigners married to a Thai</li>
            <li>
              Thailand Elite Visa - a government led program offering
              memberships including 5 year visas and other privileges
            </li>
          </ul>
        </div>
      ),
      ru: (
        <div>
          <p>
            Существуют различные формы виз, доступных для иностранцев, которые
            хотят приехать в Таиланд для учебы, ведения бизнеса, инвестиций,
            выхода на пенсию и других целей на срок от 90 дней до 1 года с
            многократным въездом. К таким визам относятся следующие:
          </p>
          <ul>
            <li>
              Образовательная виза при поступлении в зарегистрированное учебное
              заведение в Таиланде;
            </li>
            <li>Деловая виза для ведения бизнеса или рабочих целей;</li>
            <li>
              Пенсионная виза для людей в возрасте 50лет и старше,
              соответствующих установленным финансовым требованиям;
            </li>
            <li>
              Брачная виза для иностранцев, состоящих в браке с
              гражданином/гражданкой Таиланда;
            </li>
            <li>
              Thailand Elite Visa – правительственная программа членства,
              предлагающая, в том числе, визы на 5 лет и другие привилегии.
            </li>
          </ul>
        </div>
      ),
      cn: (
        <div>
          <p>
            对于希望前往泰国学习,出差,投资,享受退休生活或因其他目的前往泰国的外籍人士，当局提供多
            种形式且期限介于 90 天至 1 年的多次入境签证，其中包括:
          </p>
          <ul>
            <li>
              <strong>教育签证，</strong>适用于就读于泰国注册教育机构的人士
            </li>
            <li>
              <strong>商务签证，</strong>适用于经营公司的人士或雇员
            </li>
            <li>
              <strong>退休签证，</strong>适用于年满 50 岁且符合财务要求的人士
            </li>
            <li>
              <strong>结婚签证，</strong>适用于与泰国人结婚的外籍人士
            </li>
            <li>
              <strong>泰国精英签证，</strong>一项由政府引导的计划，提供包括 5
              年签证和其他特权
              如需了解更多信息，请咨询移民专家或泰国大使馆/领事馆。
            </li>
          </ul>
        </div>
      ),
    },
  },
  ///////////////////////////
  {
    categoryId: 2,
    question: {
      en: "What is the project area?",
      ru: "此项目占地多大？",
      cn: "Какая площадь проекта?",
    },
    displayOn: ["en"],
    answer: {
      en: (
        <div>
          <p>Phase 1 is a total area of approximately 6 rai (10,000 m2).</p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Общая площадь первого этапа строительства примерно 6 рай. (10,000
            m2).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            一期占地6莱。联排别墅和独栋别墅的占地面积将在各自的相关协议中指定。(6莱約為10,000m2)
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: {
      en: "How long does construction take?",
      ru: "Сколько времени занимает строительство?",
      cn: "建筑施工需要多长时间？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Generally it will take approximately 12 - 18 months to complete
            construction of the Townhomes and Villas.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Как правило, строительство виллы или таухауса занимает 12-18
            месяцев.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            一般而言，对于联排别墅和独立别墅，大约需要12-18个月才能完成建筑和景观绿化。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: {
      en: "Is a warranty period offered?",
      ru: "Какой гарантийный срок предлагается?",
      cn: "保修期为多久？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Yes. A one year building structure warranty is offered from the date
            of completion of construction for the Town Homes and Villas.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Один год гарантийного срока предлагается на здания и компоненты или
            аксессуары с даты завершения строительства.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            一般而言，从竣工之日起，对联排别墅和独栋别墅提供一年建筑结构保修。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: {
      en: "What is included in the property?",
      ru: "Что входит в готовый объект?",
      cn: "交房标准是什么？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Wardrobe, kitchen and landscaping is included (refer to
            specifications). Loose furniture is not included.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Шкаф, кухня и озеленение включены(см. спецификации). Невстроенная
            мебель не включена.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>包括衣柜,厨房以及绿化（请参阅规格）。家具不包括在内。</p>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: {
      en: "Is customization of the building allowed?",
      ru: "Можно ли перестраивать или перепланировать объект?",
      cn: "是否可以根据个人喜好或需要对房屋进行改建？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            All of our residential properties have been designed by professional
            architects and engineers and construction must be in accordance with
            building permits issued by the Government authorities. Other minor
            modifications for the Townhomes and Villas which do not breach the
            construction permit and do not impact the building structure such as
            internal partitions, built-in furniture, etc and which do not affect
            the overall aesthetics of the project may be done after house hand
            over (subject to developer approval).
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            План всех объектов жилой недвижимость разрабатывается
            профессионалами - ведущими архитекторами и инженерами, а
            строительство ведется в соответствии с выданными государственными
            органами разрешениями на строительство. Тем не менее, мы можем
            внести незначительные изменения, которые не нарушают условия
            полученного разрешения на строительство, и не повлияют на
            конструкцию здания. Обычно это работы, которые не влияют на общую
            эстетику постройки, например, перенос внутренних перегородок и
            изменение деталей внутренней отделки и оформления - встроенная
            мебель, стены и пол и так далее.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            我们所有的住宅物业均由顶级建筑师和工程师设计，并且依照政府机构所颁发的施工许可证进行建造。如需对联排别墅和独栋别墅进行不违反施工许可证,不影响建筑结构的小改动，例如内部隔墙,内置式家具等，需在房屋完工交付后进行，且不能影响开发项目的整体美观。（必须受到开发商​批准）。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: {
      en: "Cost for water and electricity meter installation?",
      ru: "Какие затраты на воду и установку счетчика для электричества?",
      cn: "水表和电表的安装费用是多少？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            The electricity meter deposit is THB 5,000 and THB 15,000 for
            Townhome and Villa respectively. The water meter deposit is THB 535
            for both Townhome and Villa. (These may be subject to change by the
            relevant government authority)
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Установка счетчика для электричества стоит THB 5,000 и THB 5,000
            соответственно для Таунхаусов и Вилл. Счетчик для воды 535 бат.
            (могут быть изменены в соответствии с государственными нормами)
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            电表保证金为联排别墅5千泰铢，独栋别墅1万5千泰铢。联排和独栋别墅的水表保证金都是535泰铢。（根据相关政府授权，可能有变动）。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 3,
    question: {
      en: "Is there a rental program available?",
      ru: "Существует ли программа аренды?",
      cn: "贵方是否提供任何租赁计划？如果有，潜在回报是多少？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Laguna Property will provide an optional rental/letting service for
            individual owners but a hotel-type managed rental program is
            currently not contemplated. A market-rate commission will be charged
            based upon the rental value.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Laguna Property предоставляет услугу аренды для индивидуальных
            владельцев, однако программа аренды управляемая оператором в
            настоящее время не рассматривается. Комиссия взимается на основании
            рыночного курса от стоимости аренды.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            目前不提供酒店管理式租赁方案，但乐古浪房产为个人业主提供可选租赁服务，根据市场佣金率以及房屋租金收取服务费。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 3,
    question: {
      en: "What are the taxes levied on the rental income?",
      ru:
        "Каковы налоги оплачивает владелец недвижимости при участии в  аренде?",
      cn: "出租物业的业主须缴纳哪些税费？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Generally, rental income earned by non-resident (foreign) owners is
            subject to 15% withholding tax whereas rental income earned by Thai
            tax resident is subject to 5% withholding tax.
          </p>
          <small>
            <em>
              Note: Applicable tax rates are current but may be subject to
              change by the relevant Thai authorities.
            </em>
          </small>
        </div>
      ),
      ru: (
        <div>
          <p>
            Доход от аренды обкладывается налогом, для иностранных граждан,
            налог составляет - 15%, для местных жителей Тайской национальности -
            5%.
          </p>
          <small>
            <em>
              Примечание: Применимо регистрационные сборы и налоговые ставки
              являются текущими, но могут быть изменены соответствующим властям
              Таиланда.
            </em>
          </small>
        </div>
      ),
      cn: (
        <div>
          <p>
            通常出租物业的外籍业主需缴纳15%的租金所得税；泰籍业主需缴纳5%
            的租金所得税。
          </p>
          <small>
            <em>
              备注：请注意，此处的某些适用税率可能会根据泰国法律改变而发生改变。
            </em>
          </small>
        </div>
      ),
    },
  },
  {
    categoryId: 3,
    question: {
      en: "Can I rent out the property by myself short term and/or long term?",
      ru:
        "Могу ли я сдать свою недвижимость в краткосрочную и / или долгосрочную аренду?",
      cn: "我可以自己短期或长期出租物业吗？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>Yes, terms and conditions will apply.</p>
        </div>
      ),
      ru: (
        <div>
          <p>Да, с применением сроков и условий.</p>
        </div>
      ),
      cn: (
        <div>
          <p>可以，条件和条款适用。</p>
        </div>
      ),
    },
  },
  // =========== add new =========== //
  {
    categoryId: 4,
    question: {
      en:
        "What infrastructure and common facilities are provided and who will manage these?",
      ru:
        "Какая предоставляется инфраструктура и объекты общего назначения и кто будет управлять?",
      cn: "项目包含哪些基础设施和公共设施？这些设施由谁负责管理？",
    },

    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> The infrastructure and common facilities
            includes roads and drainage, lighting, landscape areas, swimming
            pools, deck areas and water and electricity supplies. Services shall
            include 24 hours on-site security, garbage collection, cleaning and
            maintenance of infrastructure and common facilities or any other
            services as required for the common use or benefit of owners. In
            addition, owners will be entitled to access certain amenities
            including the shuttle bus service. The condominium manager shall be
            Laguna (or its designated manager).
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Инфраструктура и объекты общего пользования
            включают в себя дороги, канализацию, освещение, ландшафтные зоны,
            бассейны, площадки, водоснабжение и электроснабжение. Услуги должны
            включать 24-часовую охрану, сбор мусора, уборку и обслуживание
            инфраструктуры и мест общего пользования, а также любые другие
            услуги, необходимые для общего пользования или требуемые в интересах
            владельцев. Кроме того, владельцы будут иметь право доступа к
            определенным удобствам курорта, включая бесплатный транспорт внутри
            курорта. Управляющим кондоминиумом является Laguna (или назначенный
            ею менеджер).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            基础设施与公共设施包括：道路和排水、照明、景观区、游泳池、甲板区与水电供应。服务包括：24小时现场保安、垃圾收集、清洁打扫，以及基础设施和共同设施的维护，或其他任何业主可以共同使用或收益的服务。此外，业主将有权使用一些设施，包括穿梭巴士服务。公寓经理将由乐古浪房（或其指派之经理）担任。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 4,
    question: {
      en:
        "What are the estimated fees payable for the infrastructure, common facilities and services provided?",

      ru:
        "Каковы сборы за обслуживание инфраструктуры проекта, общественной территории и за другие предоставляемые услуги?",
      cn: "基础设施、公共设施和服务预计费用是多少?",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> The fees for the cost of maintenance for the
            infrastructure, common facilities, services provided (“common area
            fee”) and maintenance fees towards other services and facilities
            shall be Baht 585 per square wah per year (or Baht 147 per square
            meter per year) for the initial year and may be subject to change
            based upon the actual expenses incurred from time to time. The
            annual fees are determined by the total expenses incurred and
            proportionately divided amongst the sellable plot area of the
            properties in the estate.
          </p>
          <p>
            In addition, a fund shall be established for the cost of major
            repairs, replacement and/or improvement for the infrastructure and
            common facilities (“special fund”). Contributions will be made on a
            regular basis so that the fund is built up over time. The rate shall
            be Baht 25 per square metre per year for the initial year and may be
            subject to change. If the fund balance is not sufficient for the
            cost of major repairs, owners may be required to pay an additional
            amount as requested by the manager from time to time.
          </p>
          <p>
            The cost of water and electricity supplied to individual properties
            shall be based upon metered consumption.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Плата за обслуживание объектов инфраструктуры,
            мест общего пользования, предоставляемых услуг («плата за места
            общего пользования»), а также плата за коммунальные услуги и плата
            за предоставление других услуг составляет 147 батов за квадратный
            метр в год в течение первого года. Эта сумма может быть изменена в
            зависимости от фактических периодически возникающих расходов.
            Ежегодные платежи определяются на основании общей суммы понесенных
            расходов и пропорционально разделяются между предлагаемыми для
            продажи участками в комплексе.
          </p>
          <p>
            Кроме того, предусмотрено создание фонда для покрытия расходов на
            капитальный ремонт, замену и(или) улучшение объектов инфраструктуры
            и мест общего пользования («специальный фонд»). Взносы для
            пополнения фонда будут производиться на регулярной основе. Ставка
            составляет 25 батов за квадратный метр в год в течение первого года
            и может быть изменена. Если остаток средств недостаточен для
            покрытия затрат на капитальный ремонт, владельцам может требоваться
            периодически вносить дополнительную сумму по запросу управляющего.
          </p>
          <p>
            Стоимость воды и электричества, предоставляемых в отдельные
            помещения, рассчитывается на основании показаний счетчиков.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            基础设施、公共设施、提供服务(“公共区域服务费”)的维护成本费用以及对其他服务和
            设施的维护费用，第一年为每平方米 147
            泰铢，可能会根据实际费用发生变化。每年的费用由
            所产生的总费用决定，并按销售面积按比例进行分摊。
          </p>
          <p>
            另外，还应为基础设施与共同设施的主要维修、以及其更换和/或改造费用设立基金(“特别
            基金”)。该基金要求业主定期支付。初始年度费用应为每平方米 25
            泰铢，可能会有所变
            动。如果基金的余额不足以进行大修缮时，则业主可能需要根据管理方的要求，不时支付额外
            的维修费。
          </p>
          <p>各个单元的水电费用，将按计量消费为准。</p>
        </div>
      ),
    },
  },
  {
    categoryId: 4,
    question: {
      en: "What property management services are provided?",
      ru: "Какие предоставляются услуги по управлению собственностью?",
      cn: "所提供的物业管理服务有哪些？",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Laguna will provide a full range of property
            services to individual owners including, pest control, routine and
            preventative maintenance, general repairs, housekeeping and other
            reasonable requests. Rates vary according to the frequency and scope
            of service. In addition, Laguna provides owners with the ability to
            generate a rental income from their property with short-term* and
            long-term rentals (see below).
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Управляющая компания Laguna и/или сотрудники
            комплекса Skypark Phuket предоставят полный спектр услуг, включая
            борьбу с вредителями, стандартное и профилактическое обслуживание,
            общие ремонтные работы, уборку и другие виды работ по просьбе
            владельца. Стоимость услуг зависит от частоты масштаба их
            предоставления. Более того, отдел по аренде «Laguna Rentals»
            предоставляет владельцам квартир, не входящих в состав отеля,
            возможность получать дополнительный доход от сдачи их недвижимости в
            долгосрочную и краткосрочную аренду* (см. ниже).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            乐古浪将为个体业主提供全方位的物业管理服务，包括虫害防治、常规与预防性维护、一般维修、家政服务，以及其他合理要求。收费视服务的频率与范围而异。此外，通过乐古浪团队可让业主在住宅空置时以短期*和长期出租（见下文）的方式获取租金收益。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 4,
    question: {
      en: "Can I rent my unit out on my own?",
      ru: "Могу ли я самостоятельно сдать в аренду свою квартиру?",
      cn: "我是否可以自行租赁我的单位？",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Yes, owners may rent out their property on a
            long-term basis (6 months or more) directly or through external
            agents.
          </p>
          <p>
            For short-term* rentals less than 6 months, these must be conducted
            exclusively through Laguna Rentals who provides owners with the
            ability to generate a rental income from their property when not in
            residence with short-term and long-term rentals.
          </p>
          <p>
            <em>* Terms and conditions apply</em>
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Да. В случае сдачи в аренду на длительный срок
            (6 месяцев и более) нет никаких ограничений, сдача в аренду может
            быть произведена владельцем или сторонним агентом.
          </p>
          <p>
            В случае краткосрочной* аренды от 1 до 6 месяцев, все операции
            должны осуществляться через отдел по аренде Laguna Rentals,
            предоставляющий владельцам жилой недвижимости, не являющихся частью
            отеля, возможность получения дополнительного дохода с аренды их
            собственности, если те не проживают там в течение короткого или
            длительного периода.
          </p>
          <p>
            Сдача в аренду на короткий* срок менее 30 дней должна осуществляться
            исключительно через программу аренды Skypark Phuket (владеющая
            гостиничной лицензией). В квартирах, управляемых в соответствии с
            гостиничной программой сдачи в аренду, должен присутствовать
            стандартный набор мебели.
          </p>
          <p>
            <em>* Применяются определенные правила и условия.</em>
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            答.是的，业主可以直接或通过外部中介长期（6个月或更长时间）出租其房产。
          </p>
          <p>
            对于低于6个月的短期*租赁，业主就必须通过乐古浪租赁（Laguna
            Rentals）来进行。这使业主能够在不居住期间，通过短期和长期租赁从其房产中获得租金收入。
          </p>
          <p>
            <em>* 需受一定条款与条件约束。</em>
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 4,
    question: {
      en:
        "What are the taxes levied on rental income that an owner will be subject to?",
      ru:
        "Какие налоги должен будет выплачивать владелец с дохода от сдачи в аренду?",
      cn: "业主需要缴纳哪些租金收入税？",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Owners may be required to file an income tax
            return in Thailand based upon rental income earned and pay the
            applicable tax. Rental distributions made to owners may be subject
            to withholding tax under the Thai Revenue Code with rates ranging
            from 5 – 15%, subject to owners tax structure status.
          </p>
          <small>
            <em>
              Note: applicable tax rates are current at the date of issue of
              this FAQ and may be subject to changes. The unit owner shall be
              responsible for any income and any other taxes, duties and fees of
              whatever nature which may be levied by relevant authorities on the
              unit in connection with the rental.
            </em>
          </small>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Доходы с аренды, получаемые зарубежными
            гражданами, облагаются налогом в 15%. Доходы с аренды, получаемые
            гражданами Таиланда, облагаются налогом в 5%.
          </p>
          <small>
            <em>
              Примечание: приведенные налоговые ставки являются действующими на
              момент публикации данного документа с часто задаваемыми вопросами
              и могут быть пересмотрены. Владельцы собственности несут
              ответственность за получаемые доходы и уплату разнообразных
              налогов, пошлин и сборов, которые могут взиматься соответствующими
              государственными органами в связи со сдачей собственности в
              аренду.
            </em>
          </small>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            业主需要根据所赚取的租金收入在泰国提交所得税申报表并支付适用的税款。根据泰国税
            法，向业主分配的租金需要缴纳 5% 至 15%
            的税费，具体取决于业主的税收结构状况。
          </p>
          <small>
            <em>
              备注：适用的税率是本常见问题解答发布之日的现行税率，可能会有所变化。房屋持有者应对有关
              当局可能对单位征收的与租金有关的任何收入和任何其他税收、关税和费用负责。
            </em>
          </small>
        </div>
      ),
    },
  },
  // =========== add new =========== //
  {
    categoryId: 4,
    question: {
      en:
        "What types of property management services are offered and what is the approximate cost?",
      ru:
        "Какие услуги по уходу недвижимости вы предлагаете и сколько примерно они стоят?",
      cn: "贵方提供哪些类型的物业管理服务？费用大概是多少？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            In addition to common area property management by Laguna, optional
            property management services by Laguna are available to individual
            owners such as housekeeping, pool cleaning, gardening, routine and
            preventative maintenance, general repairs and pest control. Please
            contact the Property Sales Centre for further details.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            В дополнение к уходу за общей территорией владельцам недвижимости
            предлагаются дополнительные услуги. Обслуживание объектов,
            участвующих в программе аренды, осуществляется согласно условий
            программы. Сюда включены такие услуги, как уборка, чистка бассейна,
            озеленение, текущее и профилактическое обслуживание, капитальный
            ремонт и борьба с вредителями. Тем не менее, данные услуги доступны
            и для других объектов. Пожалуйста, обратитесь в Отдел продаж для
            уточнения деталей.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            除了公共区域的物业管理之外，乐古浪还为每位业主提供选择性的物业管理服务，例如家政,泳池清洁,园艺,定期和预防性维护,一般维修及病虫害防治。请联系物业销售中心，进一步了解详情。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 5,
    question: {
      en: "What privileges will I receive as an owner?",
      ru: "Какие льготы я получу как владелец недвижимости Laguna Park?",
      cn: "作为Laguna Park的业主，我将享有哪些优惠？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Owners will receive a ‘Sanctuary Club’ card which entitles holders
            to discounts and privileges at all Banyan Tree, Angsana and Laguna
            Resorts worldwide.
          </p>
          <ul>
            <li>
              {" "}
              30% discount on best available rates for hotel accommodation
            </li>
            <li> 25% discount on food and beverage</li>
            <li> 30% discount on golf green fees</li>
            <li> 20% discount on a-la-carte spa menu</li>
            <li> 15% discount on gallery merchandise</li>
            <li> 15% discount on in-house tours</li>
            <li> 15% discount on laundry</li>
            <li> 10% discount airport and ferry terminal transfers</li>
            <li> Priority wait-list on reservations</li>
            <li> Early check-in / late check-out</li>
          </ul>
          <p>**Terms and conditions apply.</p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Владельцы получат карту «Sanctuary Club», по которой предоставляются
            привилегии и скидки в отелях и на курортах Banyan Tree, Angsana и
            Laguna в разных странах мира.
          </p>
          <ul>
            <li>скидка 30% от наиболее выгодной цены на проживание в отеле</li>
            <li>скидка 25% на еду и напитки</li>
            <li>скидка 30% от стоимости пользования полем для игры в гольф</li>
            <li>скидка 20% на средства для спа-процедур по выбору</li>
            <li>скидка 15% на покупки в торговой галерее</li>
            <li>скидка 15% на туры, организуемые отелем</li>
            <li>скидка 15% на услуги прачечной</li>
            <li>
              скидка 10% на поездки из/до аэропорта и причала паромной переправы
            </li>
            <li>
              приоритетный статус при ожидании свободного номера для
              бронирования
            </li>
            <li>ранний заезд / поздний выезд</li>
          </ul>
          <p>**Могут действовать ограничения.</p>
        </div>
      ),
      cn: (
        <div>
          <p>
            业主将收到一张“榕源会俱乐部”卡，获得全球所有悦榕庄,悦椿及乐古浪度假村品牌的特权和折扣。
          </p>
          <ul>
            <li>酒店住宿最优价格7折</li>
            <li>餐饮7.5折</li>
            <li>高尔夫果岭费7折</li>
            <li>Spa按摩方式随心选8折</li>
            <li>零售艺品店商品8.5折</li>
            <li>酒店提供旅行8.5折</li>
            <li>洗衣服务8.5折</li>
            <li>机场及渡船码头接送9折</li>
            <li>优先预订</li>
            <li>提早入住/延迟退房</li>
          </ul>
          <p>**遵循附属条款。</p>
        </div>
      ),
    },
  },
  {
    categoryId: 5,
    question: {
      en: "Will the property come with a golf membership?",
      ru:
        "Будет членство в гольф клуб предоставляться владельцам недвижимости?",
      cn: "此物业业主可以获得高尔夫俱乐部的会员吗？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Yes, owners will be provided with a 5 year golf membership at Laguna
            Phuket Golf Club.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Владельцам будет предоставляться членство в Laguna Phuket Golf Club
            на 5 лет.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>是的，业主将享有5 年普吉岛乐古浪高尔夫俱乐部会籍。</p>
        </div>
      ),
    },
  },
  {
    categoryId: 6,
    question: {
      en: "What infrastructure facilities and services are provided?",
      ru: "К каким объектам инфраструктуры и услугам предоставляется доступ?",
      cn: "",
    },
    displayOn: ["en", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Being an owner in Asia’s leading resort, a collection of hotels with
            their restaurants, rejuvenating spas, recreation facilities
            (including the acclaimed Laguna Phuket Golf Club) and Canal Village
            shops are all within easy reach via the inter-resort shuttle bus and
            ferry services.{" "}
          </p>
          <p>
            The infrastructure facilities and services meet the same high
            standards of the hotels and include:{" "}
          </p>
          <ul>
            <li>Security – 24-hour security guards.</li>
            <li>Roads – private internal roads.</li>
            <li>
              Electricity – power provided by the Provincial Electricity
              Authority.
            </li>
            <li>
              Water – water from reservoirs within the complex and/or the
              Provincial Water Authority.
            </li>
            <li>
              Landscaped area – open space for recreational use by owners.
            </li>
            <li>
              Communications – each property is provided with telephone lines.
              Broadband and cable TV connections may be separately arranged.
            </li>
            <li>
              Garbage collection – provided on a daily basis by Laguna Service
              Company.
            </li>
            <li>
              Estate Management – a dedicated team of Laguna Estate Services
              oversees the 24-hour security, garbage collection, gardening and
              landscaping, general cleaning and ongoing maintenance of common
              areas.
            </li>
          </ul>
        </div>
      ),
      ru: (
        <div>
          <p>
            Любой владелец объекта на территории ведущего курорта Азии может с
            легкостью добраться до любого из пяти отелей с ресторанами, салонов,
            объектов организации отдыха и досуга (в том числе известного
            гольф-клуба Laguna Phuket Golf Сourse) и магазинов Canal Village с
            помощью бесплатных автобусов и паромов, курсирующих по всей
            территории.
          </p>
          <p>Предлагаемые высококачественные услуги и инфраструктура:</p>
          <ul>
            <li>Безопасность - 24-часовая охрана на входе каждого поселка.</li>
            <li>
              Дороги и ограждения - в каждом жилом комплексе проложены
              внутренние дороги, а по периметру установлены ограждения.
            </li>
            <li>
              Электроснабжение - электричество поставляется Местным
              департаментом электроснабжения Таиланда.
            </li>
            <li>
              Водопровод - каждое здание подключено к собственному источнику
              воды, к резервуару и/или скважине.
            </li>
            <li>
              Зеленая зона - общая территория для рекреационного использования
              владельцами.
            </li>
            <li>
              Коммуникации - каждый дом имеет две внешние телефонные линии.
              Интернет и кабельное телевидение подключаются отдельно.
            </li>
            <li>
              Вывоз мусора - ежедневный вывоз компанией Laguna Service Company.{" "}
            </li>
            <li>
              Уход за территорией - специальное Бюро по управлению недвижимостью
              осуществляет надзор за 24-часовой охраной, вывозом мусора,
              озеленением и благоустройством, генеральной уборкой и текущими
              задачами по уходу за местами общего пользования в здании. Наш
              заботливый персонал всегда рад помочь владельцам удовлетворить
              любой разумный запрос.
            </li>
          </ul>
        </div>
      ),
      cn: <div />,
    },
  },
  {
    categoryId: 6,
    question: {
      en: "What are the estimated common area charges?",
      ru: "Каков уровень платежей по уходу за общей территорией?",
      cn: "",
    },
    displayOn: ["en", "ru"],
    answer: {
      en: (
        <div>
          <p>
            The common areas are managed on behalf of owners by our dedicated
            estate management team. The annual charges that apply differ by
            development depending upon the total expenses and the total number
            of properties within a particular development among which the
            expenses will be proportionately divided. The initial estimated fee
            for Townhomes and Villas shall be Baht 400 / square wah per year.
          </p>
          <p>
            In addition, a sinking fund is established for each development. The
            purpose of the sinking fund is to accumulate funds for major
            infrastructure repairs and/or improvements which may be undertaken
            in the future. Rather than charge a large upfront amount,
            contributions will be sought on a regular basis so that the fund is
            built up over time. The initial estimated fee for the Townhomes and
            Villas shall be Baht 100 / square wah per year.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Уход за территорией общего пользования осуществляется от имени
            владельцев нашей специальной службой. Сумма ежегодных платежей
            зависит от самого объекта и общего количества помещений в здании,
            среди которых будут пропорционально разделены расходы. Годичный
            взнос составляет 400 бат / вах² в год.
          </p>
          <p>
            Кроме того, для каждого проекта создается амортизационный фонд. Цель
            амортизационного фонда - накопление средств на капитальный ремонт
            инфраструктуры и/или улучшения, которые будет решено сделать в
            будущем. Фонд создается путем незначительных поступлений на
            регулярной основе, что позволяет исключить необходимость отплаты
            крупных сумм при необходимости ремонта. Годовой взнос составляет 100
            бат/ вах² в год.
          </p>
        </div>
      ),
      cn: <div />,
    },
  },
  {
    categoryId: 6,
    question: {
      en: "Are pets allowed?",
      ru: "Можно иметь домашних животных",
      cn: "",
    },
    displayOn: ["en", "ru"],
    answer: {
      en: (
        <div>
          <p>Yes, subject to rules and regulations.</p>
        </div>
      ),
      ru: (
        <div>
          <p>YДа, с приминением правил и условий.</p>
        </div>
      ),
      cn: <div />,
    },
  },
  {
    categoryId: 7,
    question: {
      en: "What are the terms of payment?",
      ru: "Какие условия оплаты существуют?",
      cn: "付款方式是什么？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>There are 2 options available:</p>
          <p>
            <strong>
              Option 1: 100% Payment upon purchase / during construction
            </strong>
            <br />
            100% payment upon purchase for already completed properties.
            Progressive payments for properties under construction are as per
            the table below.
          </p>
          <table>
            <thead>
              <tr>
                <th>Construction Payment Term</th>
                <th className="th-col2">Of Selling Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  1<sup>st</sup> Payment upon signing contract
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2<sup>nd</sup> Payment when construction is 25% complete
                  <sup>1</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  3<sup>rd</sup> Payment when construction is 50% complete
                  <sup>2</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  4<sup>th</sup> Payment when construction is 75% complete
                  <sup>3</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  5<sup>th</sup> Payment upon completion of construction
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>Total</td>
                <td className="td-col2">100%</td>
              </tr>
            </tbody>
          </table>
          <small>Notes:</small>
          <ol className="notes">
            <li>
              <small>
                Areas and dimensions are approximate and subject to final survey
                and change.
              </small>
            </li>
            <li>
              <small>
                Prices include fixed furnishing and do not include loose
                furniture.
              </small>
            </li>
            <li>
              <small>Concrete structure substantially completed.</small>
            </li>
            <li>
              <small>
                Roof, brickwork and rendering substantially completed.
              </small>
            </li>
            <li>
              <small>
                Electrical conduits, pipework and plastering substantially
                completed.
              </small>
            </li>
            <li>
              <small>
                Interest will be applied to the post-construction deferred
                balance as outlined under Financing Option
              </small>
            </li>
          </ol>
          <p>
            <strong>
              Option 2: 50% payment upon purchase / during construction with 50%
              deferred payment over 1, 3 or 5 years
            </strong>
            <br />
            50% payment upon purchase for already completed properties.
            Progressive payments for properties under construction (50% during
            construction / 50% post construction) as per the table below
          </p>

          <table>
            <thead>
              <tr>
                <th>Deferred Payment Plan</th>
                <th className="th-col2">Of Selling Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  1<sup>st</sup> Payment upon signing contract
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2<sup>nd</sup> Payment when construction is 50% complete
                  <sup>1</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  3<sup>rd</sup> Payment when construction is 75% complete
                  <sup>2</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  4<sup>th</sup> Payment upon completion of construction
                  <sup>3</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  Post construction payments
                  <sup>4</sup>
                </td>
                <td className="td-col2">50%</td>
              </tr>
            </tbody>
          </table>

          <table>
            <thead>
              <tr>
                <th>Financing Options</th>
                <th className="th-col2">
                  Interest Rate
                  <br />
                  (per annum)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 Year (4 quarterly installments)</td>
                <td className="td-col2">3%</td>
              </tr>
              <tr>
                <td>3 Year (12 quarterly installments)</td>
                <td className="td-col2">5%</td>
              </tr>
              <tr>
                <td>5 Year (20 quarterly installments)</td>
                <td className="td-col2">7%</td>
              </tr>
            </tbody>
          </table>
          <small>Notes:</small>
          <ol className="notes">
            <li>
              <small>
                Areas and dimensions are approximate and subject to final survey
                and change.
              </small>
            </li>
            <li>
              <small>
                Prices include fixed furnishing and do not include loose
                furniture.
              </small>
            </li>
            <li>
              <small>Concrete structure substantially completed.</small>
            </li>
            <li>
              <small>
                Roof, brickwork and rendering substantially completed.
              </small>
            </li>
            <li>
              <small>
                Electrical conduits, pipework and plastering substantially
                completed.
              </small>
            </li>
            <li>
              <small>
                Interest will be applied to the post-construction deferred
                balance as outlined under Financing Option
              </small>
            </li>
          </ol>

          <table className="table-center">
            <tbody>
              <tr className="tr-title">
                <td rowSpan="2" className="td-title">
                  <strong>Price</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Reservation Deposit</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>
                    Construction Completion <br />
                    Payment 50% (Minus Deposit)
                  </strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Remaining Post Finance 50%</strong>
                </td>
                <td colSpan="3" className="td-group-title">
                  <strong>Quaterly Installment</strong>
                </td>
              </tr>
              <tr className="tr-title">
                <td className="td-title">
                  <strong>1 Year (3%)</strong>
                </td>
                <td className="td-title">
                  <strong>3 Year (5%)</strong>
                </td>
                <td>
                  <strong>5 Year (7%)</strong>
                </td>
              </tr>
              <tr>
                <td>12,000,000</td>
                <td>100,000</td>
                <td>5,900,000</td>
                <td>6,000,000</td>
                <td>1,528,230</td>
                <td>541,550</td>
                <td>358,147</td>
              </tr>
              <tr>
                <td>13,000,000</td>
                <td>100,000</td>
                <td>6,400,000</td>
                <td>6,500,000</td>
                <td>1,655,583</td>
                <td>586,679</td>
                <td>387,993</td>
              </tr>
              <tr>
                <td>14,000,000</td>
                <td>100,000</td>
                <td>6,900,000</td>
                <td>7,000,000</td>
                <td>1,782,935</td>
                <td>631,808</td>
                <td>417,839</td>
              </tr>
              <tr>
                <td>15,000,000</td>
                <td>100,000</td>
                <td>7,400,000</td>
                <td>7,500,000</td>
                <td>1,910,288</td>
                <td>676,937</td>
                <td>447,684</td>
              </tr>
              <tr>
                <td>16,000,000</td>
                <td>100,000</td>
                <td>7,900,000</td>
                <td>8,000,000</td>
                <td>2,037,640</td>
                <td>722,066</td>
                <td>477,530</td>
              </tr>
              <tr>
                <td>17,000,000</td>
                <td>100,000</td>
                <td>8,400,000</td>
                <td>8,500,000</td>
                <td>2,164,993</td>
                <td>767,196</td>
                <td>507,375</td>
              </tr>
              <tr>
                <td>18,000,000</td>
                <td>100,000</td>
                <td>8,900,000</td>
                <td>9,000,000</td>
                <td>2,292,345</td>
                <td>812,325</td>
                <td>537,221</td>
              </tr>
              <tr>
                <td>19,000,000</td>
                <td>100,000</td>
                <td>9,400,000</td>
                <td>9,500,000</td>
                <td>2,419,698</td>
                <td>857,454</td>
                <td>567,067</td>
              </tr>
              <tr>
                <td>20,000,000</td>
                <td>100,000</td>
                <td>9,900,000</td>
                <td>10,000,000</td>
                <td>2,547,050</td>
                <td>902,583</td>
                <td>596,912</td>
              </tr>
              <tr>
                <td>21,000,000</td>
                <td>100,000</td>
                <td>10,400,000</td>
                <td>10,500,000</td>
                <td>2,674,403</td>
                <td>947,712</td>
                <td>626,758</td>
              </tr>
              <tr>
                <td>22,000,000</td>
                <td>100,000</td>
                <td>10,900,000</td>
                <td>11,000,000</td>
                <td>2,801,755</td>
                <td>992,841</td>
                <td>656,603</td>
              </tr>
            </tbody>
          </table>
          <small>Notes:</small>
          <ol className="notes">
            <li>
              <small>All amounts are stated in Thai Baht (THB). </small>
            </li>
            <li>
              <small>
                The above table sets out the estimated payments required under
                the respective payment plans for selling prices between THB
                12,000,000 – 22,000,000
              </small>
            </li>
            <li>
              <small>
                The estimated payments are indicative only and the developer /
                seller does not accept any responsibility or liability
                whatsoever for any inaccuracies or omissions.
              </small>
            </li>
            <li>
              <small>Payment terms are subject to change without notice.</small>
            </li>
          </ol>
        </div>
      ),
      ru: (
        <div>
          <p>
            Для всех новых объектов недвижимости мы предлагаем 2 варианта
            оплаты. Условия оплаты：
          </p>
          <p>
            <strong>
              Вариант 1: 100% оплата при покупке / во время строительства
            </strong>
            <br />
            100% оплата при покупке готовых объектов. Прогрессивные платежи для
            строящихся объектов в с нижеприведенной таблице.
          </p>
          <table>
            <thead>
              <tr>
                <th>Резервационный депозит</th>
                <th className="th-col2">Тайских Батах</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  1<sup>й</sup> платеж при подписании договора
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2<sup>й</sup> при выполнении 25% строительных работ
                  <sup>1</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  3<sup>й</sup> при выполнении 50% строительных работ
                  <sup>2</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  4<sup>й</sup> при выполнении 75% строительных работ
                  <sup>3</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  5<sup>й</sup> при завершении строительства
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>Итого</td>
                <td className="td-col2">100%</td>
              </tr>
            </tbody>
          </table>
          <small>Примечание:</small>
          <ol className="notes">
            <li>
              <small>
                Площади и размеры указаны приблизительно и могут изменяться по
                итогам финальных измерений.
              </small>
            </li>
            <li>
              <small>
                Цены включают встроенную меблировку; невстроенная мебель не
                включена.
              </small>
            </li>
            <li>
              <small>Бетонная конструкция в основном завершена.</small>
            </li>
            <li>
              <small>
                Крыша, укладка кирпича и наружная отделка в основном завершены.
              </small>
            </li>
            <li>
              <small>
                Электрическая проводка, укладка водопроводных труб и внутренняя
                отделка в основном завершены.
              </small>
            </li>
            <li>
              <small>
                Проценты по рассрочке будут начислены на отложенные платежи по
                окончании строительства, как указано в таблице «Варианты
                финансирования»
              </small>
            </li>
          </ol>
          <p>
            <strong>Вариант 2: Оплаты в рассрочку</strong>
            Первые 50% по этапам строительства и вторые 50% в рассрочку в
            течение 1, 3 или 5 лет в зависимости от выбранного плана оплаты.
            <br />
            50% оплаты при покупке завершенных объектов и оплата в рассрочку для
            строящихся объектов (50% по этапам строительства / 50% после
            завершения строительства) смотрите таблицу изложенную ниже.
          </p>

          <table>
            <thead>
              <tr>
                <th>Резервационный депозит</th>
                <th className="th-col2">Тайских Батах</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  1<sup>й</sup> платеж при подписании договора
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2<sup>й</sup> при выполнении 50% строительных работ
                  <sup>1</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  3<sup>й</sup> при выполнении 75% строительных работ
                  <sup>2</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  4<sup>й</sup> при завершении строительства
                  <sup>3</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  Платеж после завершения строительства
                  <sup>4</sup>
                </td>
                <td className="td-col2">50%</td>
              </tr>
            </tbody>
          </table>

          <table>
            <thead>
              <tr>
                <th>Варианты финансирования</th>
                <th className="th-col2">
                  Процентная
                  <br />
                  ставка
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 год (4 ежеквартальных платежа)</td>
                <td className="td-col2">3%</td>
              </tr>
              <tr>
                <td>3 года (12 ежеквартальных платежей)</td>
                <td className="td-col2">5%</td>
              </tr>
              <tr>
                <td>5 лет (20 ежеквартальных платежей)</td>
                <td className="td-col2">7%</td>
              </tr>
            </tbody>
          </table>
          <small>Примечание:</small>
          <ol className="notes">
            <li>
              <small>
                Площади и размеры указаны приблизительно и могут изменяться по
                итогам финальных измерений.
              </small>
            </li>
            <li>
              <small>
                Цены включают встроенную меблировку; невстроенная мебель не
                включена.
              </small>
            </li>
            <li>
              <small>Бетонная конструкция в основном завершена.</small>
            </li>
            <li>
              <small>
                Крыша, укладка кирпича и наружная отделка в основном завершены.
              </small>
            </li>
            <li>
              <small>
                Электрическая проводка, укладка водопроводных труб и внутренняя
                отделка в основном завершены.
              </small>
            </li>
            <li>
              <small>
                Проценты по рассрочке будут начислены на отложенные платежи по
                окончании строительства, как указано в таблице «Варианты
                финансирования»
              </small>
            </li>
          </ol>

          <table className="table-center">
            <tbody>
              <tr className="tr-title">
                <td rowSpan="2" className="td-title">
                  <strong>Цена</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Депозит</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>
                    Оплата 50% при
                    <br />
                    подписание контракта
                    <br />
                    (минус депозит)
                  </strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>
                    Оплата вторых
                    <br />
                    50% после
                    <br />
                    завершения строительства
                  </strong>
                </td>
                <td colSpan="3">
                  <strong>Ежемесячные платежи</strong>
                </td>
              </tr>
              <tr className="tr-title">
                <td className="td-title">
                  <strong>1 год (3%)</strong>
                </td>
                <td className="td-title">
                  <strong>3 года (5%)</strong>
                </td>
                <td>
                  <strong>5 год (7%)</strong>
                </td>
              </tr>
              <tr>
                <td>12,000,000</td>
                <td>100,000</td>
                <td>5,900,000</td>
                <td>6,000,000</td>
                <td>1,528,230</td>
                <td>541,550</td>
                <td>358,147</td>
              </tr>
              <tr>
                <td>13,000,000</td>
                <td>100,000</td>
                <td>6,400,000</td>
                <td>6,500,000</td>
                <td>1,655,583</td>
                <td>586,679</td>
                <td>387,993</td>
              </tr>
              <tr>
                <td>14,000,000</td>
                <td>100,000</td>
                <td>6,900,000</td>
                <td>7,000,000</td>
                <td>1,782,935</td>
                <td>631,808</td>
                <td>417,839</td>
              </tr>
              <tr>
                <td>15,000,000</td>
                <td>100,000</td>
                <td>7,400,000</td>
                <td>7,500,000</td>
                <td>1,910,288</td>
                <td>676,937</td>
                <td>447,684</td>
              </tr>
              <tr>
                <td>16,000,000</td>
                <td>100,000</td>
                <td>7,900,000</td>
                <td>8,000,000</td>
                <td>2,037,640</td>
                <td>722,066</td>
                <td>477,530</td>
              </tr>
              <tr>
                <td>17,000,000</td>
                <td>100,000</td>
                <td>8,400,000</td>
                <td>8,500,000</td>
                <td>2,164,993</td>
                <td>767,196</td>
                <td>507,375</td>
              </tr>
              <tr>
                <td>18,000,000</td>
                <td>100,000</td>
                <td>8,900,000</td>
                <td>9,000,000</td>
                <td>2,292,345</td>
                <td>812,325</td>
                <td>537,221</td>
              </tr>
              <tr>
                <td>19,000,000</td>
                <td>100,000</td>
                <td>9,400,000</td>
                <td>9,500,000</td>
                <td>2,419,698</td>
                <td>857,454</td>
                <td>567,067</td>
              </tr>
              <tr>
                <td>20,000,000</td>
                <td>100,000</td>
                <td>9,900,000</td>
                <td>10,000,000</td>
                <td>2,547,050</td>
                <td>902,583</td>
                <td>596,912</td>
              </tr>
              <tr>
                <td>21,000,000</td>
                <td>100,000</td>
                <td>10,400,000</td>
                <td>10,500,000</td>
                <td>2,674,403</td>
                <td>947,712</td>
                <td>626,758</td>
              </tr>
              <tr>
                <td>22,000,000</td>
                <td>100,000</td>
                <td>10,900,000</td>
                <td>11,000,000</td>
                <td>2,801,755</td>
                <td>992,841</td>
                <td>656,603</td>
              </tr>
            </tbody>
          </table>
          <small>Примечания:</small>
          <ol className="notes">
            <li>
              <small>Все суммы указаны в Батах</small>
            </li>
            <li>
              <small>
                В таблице выше указаны предполагаемые платежи, в рамках
                соответствующих планов оплаты объектов, стоимостью между
                12,000,000-22,000,000 Батт.
              </small>
            </li>
            <li>
              <small>
                Платежи являются лишь ориентировочными и строитель / продавец не
                несет ответственность за любые неточности или ошибки.
              </small>
            </li>
            <li>
              <small>
                Условия оплаты могут быть изменены без предварительного
                уведомления.
              </small>
            </li>
          </ol>
        </div>
      ),
      cn: (
        <div>
          <p>对于所有出售的新物业，我们提供两种付款计划。 付款方式如下：</p>
          <p>
            <strong>选择1：100% 购买价格付款或建造期间付款</strong>
            <br />
            对于已建成物业，依据购买价格100%付款。对于在建物业，依据下表按进度分期付款。
          </p>
          <table>
            <thead>
              <tr>
                <th>按建造分期付款</th>
                <th className="th-col2">销售价格</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>首笔款项于签订购买合同支付</td>
                <td className="td-col2">销售价的20%</td>
              </tr>
              <tr>
                <td>
                  第二笔款项于工程完成25%时支付
                  <sup>1</sup>
                </td>
                <td className="td-col2">销售价的20%</td>
              </tr>
              <tr>
                <td>
                  第三笔款项于工程完成50%时支付
                  <sup>2</sup>
                </td>
                <td className="td-col2">销售价的20%</td>
              </tr>
              <tr>
                <td>
                  第四笔款项于工程完成75%时支付
                  <sup>3</sup>
                </td>
                <td className="td-col2">销售价的20%</td>
              </tr>
              <tr>
                <td>第五笔款项于工程完成时支付</td>
                <td className="td-col2">销售价的20%</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>总额</td>
                <td className="td-col2">销售价格的100%</td>
              </tr>
            </tbody>
          </table>
          <small>备注：</small>
          <ol className="notes">
            <li>
              <small>面积与尺寸仅为预估，实际数据以最终测绘为准</small>
            </li>
            <li>
              <small>价格包含装修，不包含可移动家具</small>
            </li>
            <li>
              <small>混凝土基础结构工程完成</small>
            </li>
            <li>
              <small>外墙及封顶工程完成</small>
            </li>
            <li>
              <small>水电工程，管道及水泥抹平工程完成</small>
            </li>
            <li>
              <small>
                利息将根据所选付款方案以截至竣工付款之后的剩余房款余额计算
              </small>
            </li>
          </ol>
          <p>
            <strong>
              选择2：50% 购买价格付款或建造期间付款，50%延期1年,3年或5年付款。
            </strong>
            <br />
            对于已建成物业，依据购买价格的50%付款。对于在建物业，依据下表按进度分期付款（50%建造期间支付
            / 50%建造完成时支付）。
          </p>

          <table>
            <thead>
              <tr>
                <th>预定金</th>
                <th className="th-col2">泰铢</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>首笔款项于签订购买合同支付</td>
                <td className="td-col2">销售价的20%</td>
              </tr>
              <tr>
                <td>
                  第二笔款项于工程完成50%之时支付
                  <sup>1</sup>
                </td>
                <td className="td-col2">销售价的10%</td>
              </tr>
              <tr>
                <td>
                  第三笔款项于工程完成75%时支付
                  <sup>2</sup>
                </td>
                <td className="td-col2">销售价的10%</td>
              </tr>
              <tr>
                <td>
                  第四笔款项于工程完工时支付
                  <sup>3</sup>
                </td>
                <td className="td-col2">销售价的10%</td>
              </tr>
              <tr>
                <td>
                  建成后支付
                  <sup>4</sup>
                </td>
                <td className="td-col2">销售价的50%</td>
              </tr>
            </tbody>
          </table>

          <table>
            <thead>
              <tr>
                <th>财务选择</th>
                <th className="th-col2">利率</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1年 (4 个季度分期)</td>
                <td className="td-col2">3%</td>
              </tr>
              <tr>
                <td>3年 (12 个季度分期)</td>
                <td className="td-col2">5%</td>
              </tr>
              <tr>
                <td>5年 (20 个季度分期)</td>
                <td className="td-col2">7%</td>
              </tr>
            </tbody>
          </table>
          <small>备注：</small>
          <ol className="notes">
            <li>
              <small>面积与尺寸仅为预估，实际数据以最终测绘为准</small>
            </li>
            <li>
              <small>价格包含装修，不包含可移动家具</small>
            </li>
            <li>
              <small>混凝土基础结构工程完成</small>
            </li>
            <li>
              <small>外墙及封顶工程完成</small>
            </li>
            <li>
              <small>水电工程，管道及水泥抹平工程完成</small>
            </li>
            <li>
              <small>
                利息将根据所选付款方案以截至竣工付款之后的剩余房款余额计算
              </small>
            </li>
          </ol>

          <table className="table-center">
            <tbody>
              <tr className="tr-title">
                <td rowSpan="2" className="td-title">
                  <strong>售价</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>预定金</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>施工期间付 款 50% （减去定金）</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>竣工后付款 剩余50%</strong>
                </td>
                <td colSpan="3">
                  <strong>按月分期付款</strong>
                </td>
              </tr>
              <tr className="tr-title">
                <td className="td-title">
                  <strong>1 年 (3%)</strong>
                </td>
                <td className="td-title">
                  <strong>3 年 (5%)</strong>
                </td>
                <td>
                  <strong>5 年 (7%)</strong>
                </td>
              </tr>
              <tr>
                <td>12,000,000</td>
                <td>100,000</td>
                <td>5,900,000</td>
                <td>6,000,000</td>
                <td>1,528,230</td>
                <td>541,550</td>
                <td>358,147</td>
              </tr>
              <tr>
                <td>13,000,000</td>
                <td>100,000</td>
                <td>6,400,000</td>
                <td>6,500,000</td>
                <td>1,655,583</td>
                <td>586,679</td>
                <td>387,993</td>
              </tr>
              <tr>
                <td>14,000,000</td>
                <td>100,000</td>
                <td>6,900,000</td>
                <td>7,000,000</td>
                <td>1,782,935</td>
                <td>631,808</td>
                <td>417,839</td>
              </tr>
              <tr>
                <td>15,000,000</td>
                <td>100,000</td>
                <td>7,400,000</td>
                <td>7,500,000</td>
                <td>1,910,288</td>
                <td>676,937</td>
                <td>447,684</td>
              </tr>
              <tr>
                <td>16,000,000</td>
                <td>100,000</td>
                <td>7,900,000</td>
                <td>8,000,000</td>
                <td>2,037,640</td>
                <td>722,066</td>
                <td>477,530</td>
              </tr>
              <tr>
                <td>17,000,000</td>
                <td>100,000</td>
                <td>8,400,000</td>
                <td>8,500,000</td>
                <td>2,164,993</td>
                <td>767,196</td>
                <td>507,375</td>
              </tr>
              <tr>
                <td>18,000,000</td>
                <td>100,000</td>
                <td>8,900,000</td>
                <td>9,000,000</td>
                <td>2,292,345</td>
                <td>812,325</td>
                <td>537,221</td>
              </tr>
              <tr>
                <td>19,000,000</td>
                <td>100,000</td>
                <td>9,400,000</td>
                <td>9,500,000</td>
                <td>2,419,698</td>
                <td>857,454</td>
                <td>567,067</td>
              </tr>
              <tr>
                <td>20,000,000</td>
                <td>100,000</td>
                <td>9,900,000</td>
                <td>10,000,000</td>
                <td>2,547,050</td>
                <td>902,583</td>
                <td>596,912</td>
              </tr>
              <tr>
                <td>21,000,000</td>
                <td>100,000</td>
                <td>10,400,000</td>
                <td>10,500,000</td>
                <td>2,674,403</td>
                <td>947,712</td>
                <td>626,758</td>
              </tr>
              <tr>
                <td>22,000,000</td>
                <td>100,000</td>
                <td>10,900,000</td>
                <td>11,000,000</td>
                <td>2,801,755</td>
                <td>992,841</td>
                <td>656,603</td>
              </tr>
            </tbody>
          </table>
          <small>备注：</small>
          <ol className="notes">
            <li>
              <small>所有金额均以泰铢表示。</small>
            </li>
            <li>
              <small>
                上表列出了销售价格为 12,000,000-22,000,000
                泰铢时，相应付款计划所需支付的预计金额。
              </small>
            </li>
            <li>
              <small>
                预计付款额仅作示意参考用途。如有错漏，开发商/销售方概不负责。
              </small>
            </li>
            <li>
              <small>付款方式如有更改，恕不另行通知。</small>
            </li>
          </ol>
        </div>
      ),
    },
  },
];

export { category, faqs };



// WEBPACK FOOTER //
// ./src/data/PhuketLagunaPark2/faq.js